<template>
  <hb-basic-page
    :action-buttons="$vuetify.breakpoint.smAndDown ? { add: titleButton } : {}"
    :fill-height="richCategories.length === 0"
    :loading="loading"
    :search-title="`${$t('categories.search')}...`"
    :subtle-loading="subtleLoading"
    :title="$tc('categories.title', 2)"
    :title-button="titleButton"
    name="categories-view"
    @handle-search="handleSearch"
  >

    <v-col v-if="!loading && richCategories.length > 0" cols="12" lg="8" md="10" offset-lg="2" offset-md="1"
           offset-xl="3"
           xl="6">
      <v-row>
        <v-col cols="12">
          <SectionHeader icon="mdi mdi-clipboard-list-outline">
            <v-icon color="primary" left size="36"></v-icon>
            {{ $tc('categories.title', 2) }}
          </SectionHeader>
          <v-card>
            <v-card-text>
              <v-list dense>
                <template v-for="category in richCategories">
                  <category-item :key="category.key" :category="category" @edit="handleEditCategory" @reload="reload"/>
                </template>
              </v-list>
              <v-btn block color="primary" text x-large @click="handleCreateCategory">
                <v-icon left>add</v-icon>
                {{ $t('categories.create') }}
              </v-btn>
            </v-card-text>

          </v-card>
        </v-col>

      </v-row>

    </v-col>

    <v-col v-if="!loading && richCategories.length === 0" class="pa-0 fill-height" cols="12">
      <v-row align="center" class="fill-height" no-gutters>
        <no-content-view v-if="!loading && richCategories.length === 0"
                         :description="$t('categories.create_first_category_help')"
                         :function-button="true"
                         :function-button-text="$t('categories.create')"
                         :prop-function="handleCreateCategory"
                         :reload-button="false"
                         :title="$t('categories.create_first_category')"
                         function-button-icon="add"
                         title-icon="mdi mdi-shape"/>
      </v-row>
    </v-col>

    <category-edit-dialog ref="categoryEditDialog" @edit="handleEditCategory" @refresh="reload"/>

  </hb-basic-page>
</template>

<script>
import NoContentView from "@/components/NoContentView";
import SectionHeader from "@/components/SectionHeader";
import CategoryItem from "@/components/Category/CategoryItem";
import CategoryEditDialog from "@/components/Category/CategoryEditDialog";
import categoryService from '@/service/category.service'

export default {
  name: 'CategoriesView',
  components: {CategoryEditDialog, CategoryItem, SectionHeader, NoContentView},
  data() {
    return {
      loading: true,
      subtleLoading: false,
      searchPhrase: '',
      titleButton: {
        text: this.$t('categories.create'),
        icon: 'add',
        callback: this.handleCreateCategory,
        primary: true,
      },
    };
  },
  computed: {
    richCategories() {
      return this.getCategoriesRecursively(this.categories.filter(c => !c.parentCategory));
    },
    categories() {
      return categoryService.categories;
    }
  },
  methods: {
    handleSearch(searchPhrase) {
      this.searchPhrase = searchPhrase;
    },
    getCategoriesRecursively(categories, level = 0) {
      return categories.map(c => {
        c.level = level;
        c.children = this.getCategoriesRecursively(this.categories.filter(cc => cc.parentCategory?.id === c.id), level + 1);
        return c;
      });
    },
    handleCreateCategory() {
      this.$refs.categoryEditDialog.open();
    },
    handleEditCategory(category) {
      this.$refs.categoryEditDialog.open(category)
    },

    async reload() {
      this.loading = true;
      if (this.categories.length > 0) this.subtleLoading = true;
      await categoryService.getCategories();
      this.loading = false;
      this.subtleLoading = false;
    }
  },
  mounted() {
    if (!this.$hasMatchingRoles(['admin'])) {
      this.$router.replace({name: 'access_denied'});
      return;
    }
    this.loading = true;
    this.reload();
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="scss"></style>
